/*
  hasrslt
*/
/**
 * Desktop/Mobile Results Management
 */

/************************************************
		DISPLAY OR HIDE ELEMENTS BASED ON THE RESULTS
    RECEIVED BY A PAGE
    uses the following attributes:
    data-paging, data-hasrslt, data-norslt
    data-paging tagged elements are modules which contains some results
    data-hasrslt tagged elements are modules which will be displayed if there are results
    data-norslt tagged elements are modules which will be hidden if there are no results

    Activated only on some pages
*************************************************/
var __HASRSLT = {
  auth_pages: ['srslt_p', 'srslt_m', 'favp', 'mctp'],
  init: function() {
    //-- if on a valid page
    if (in_array(PAGE_CODE, __HASRSLT.auth_pages)) {

      //-- get paging elements (first one met)
      var paging_el = $('[data-paging]').eq(0);

      //-- get hasrslt elements
      var has_els = $('[data-hasrslt]');

      //-- get norslt elements
      var no_els = $('[data-norslt]');

      //-- if at least 1 paging element & (one has_els or one no_els) exists
      if ((has_els.length > 0 || no_els.length > 0) && paging_el.length > 0) {

        //-- get first list of results
        var list = paging_el.find("." + paging_el.attr("data-paging")).eq(0);

        //-- count number of results
        var results = list.children().length;

        if (results > 0) {
          has_els.show();
          no_els.hide();
        }
        else {
          has_els.hide();
          no_els.show();
        }
      }
    }
  }
};

__HASRSLT.init();
